import classNames from "classnames";
import { useLocalStorage } from "react-use";

const SlideBarcode = ({
  zoom,
  DEFAULT_ZOOM,
  barcode_image_url,
  macro_image_url,
}: {
  zoom: number;
  DEFAULT_ZOOM: number;
  barcode_image_url?: string;
  macro_image_url?: string;
}) => {
  const [zoomed, setZoomed] = useLocalStorage<boolean>("barcodeZoomed", false);
  return (
    <div
      className={classNames(
        "Barcode",
        zoom <= 1 * DEFAULT_ZOOM ? "Barcode--on" : "Barcode--off",
        zoomed ? "Barcode--lg" : "Barcode--sm"
      )}
      onClick={() => setZoomed(!zoomed)}
    >
      {barcode_image_url ? (
        barcode_image_url !== "MISSING" ? (
          <figure>
            <img src={barcode_image_url} alt="" />
          </figure>
        ) : (
          <div className="missing_barcode">BARCODE MISSING</div>
        )
      ) : (
        <></>
      )}
      {macro_image_url ? (
        macro_image_url !== "MISSING" ? (
          <figure>
            <img src={macro_image_url} alt="" />
          </figure>
        ) : (
          <div className="missing_macro">
            <p>MACRO</p>
            <p>IMAGE</p>
            <p>MISSING</p>
          </div>
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default SlideBarcode;
